<script setup lang="ts">
import { THEME_OPTIONS } from '../themeData'

defineProps<{
  modelValue: string
  includeAuto?: boolean
}>()

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()
</script>

<template>
  <div class="theme-gallery">
    <button
      v-if="includeAuto"
      type="button"
      class="theme-card theme-card--auto"
      :class="{ 'is-selected': modelValue === 'auto' }"
      @click="emit('update:modelValue', 'auto')"
    >
      <span class="theme-card__auto-art" aria-hidden="true">
        <i></i><i></i><i></i>
      </span>
      <span class="theme-card__copy">
        <strong>Подобрать под тему</strong>
        <small>Соберём палитру и ритм специально для вашего сюжета.</small>
      </span>
      <span class="theme-card__check" aria-hidden="true">✓</span>
    </button>

    <button
      v-for="theme in THEME_OPTIONS"
      :key="theme.id"
      type="button"
      class="theme-card"
      :class="{ 'is-selected': modelValue === theme.id }"
      @click="emit('update:modelValue', theme.id)"
    >
      <span class="theme-card__preview">
        <img :src="theme.preview" :alt="`Превью темы «${theme.name}»`">
      </span>
      <span class="theme-card__copy">
        <strong>{{ theme.name }}</strong>
        <small>{{ theme.description }}</small>
      </span>
      <span class="theme-card__check" aria-hidden="true">✓</span>
    </button>
  </div>
</template>
